import { FC } from 'react'

import AppsIcon from '@mui/icons-material/Apps'
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto'
import BookIcon from '@mui/icons-material/Book'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ConstructionIcon from '@mui/icons-material/Construction'
import PeopleIcon from '@mui/icons-material/People'
import SegmentIcon from '@mui/icons-material/Segment'
import SettingsIcon from '@mui/icons-material/Settings'
import StorageIcon from '@mui/icons-material/Storage'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import { Divider, IconButton, List, Toolbar } from '@mui/material'
import {
  IS_CFR_ENABLED,
  IS_DANONE_ENV,
  IS_DEV,
  IS_JUME_ENV,
  IS_PRGM_ENV,
  IS_RTM_ENABLED,
  IS_TETRIS_ENABLED,
} from 'constants/config'
import { Routes } from 'constants/routes'

import { Menu } from './Menu'
import { MenuCollapse } from './MenuCollapse'
import { NavItem } from './NavItem'

interface SidebarProps {
  isOpen: boolean
  toggleDrawer: VoidFunction
}

export const Sidebar: FC<SidebarProps> = ({ isOpen, toggleDrawer }) => (
  <Menu isOpen={isOpen} variant="permanent">
    <Toolbar
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        px: [1],
      }}
    >
      <IconButton onClick={toggleDrawer}>
        <ChevronLeftIcon />
      </IconButton>
    </Toolbar>
    <Divider />
    <List component="nav">
      <NavItem icon={<AppsIcon />} path={Routes.Projects} title="Проекты" />
      <NavItem icon={<PeopleIcon />} path={Routes.Users} title="Пользователи" />
      <NavItem icon={<AssistantPhotoIcon />} path={Routes.Groups} title="Права доступа" />
      {IS_JUME_ENV && <NavItem icon={<SettingsIcon />} path={Routes.Config} title="Настройки" />}
      <Divider sx={{ my: 1 }} />
      <NavItem icon={<TextFieldsIcon />} path={Routes.BusinessTypes} title="Бизнес-типы" />
      <NavItem icon={<StorageIcon />} path={Routes.Fields} title="Поля" />
      <NavItem exact icon={<ConstructionIcon />} path={Routes.Templates} title="Шаблоны" />
      {IS_DANONE_ENV && IS_DEV && (
        <>
          <NavItem exact icon={<BookIcon />} path={Routes.PrgmManuals} title="Справочники" />
          <NavItem exact icon={<BookIcon />} path={Routes.PrgmValidation} title="Валидация" />
        </>
      )}

      <Divider sx={{ my: 1 }} />
      <MenuCollapse icon={<SegmentIcon />} title="Промо">
        <NavItem exact icon={<SegmentIcon />} path={Routes.PromoGroups} title="Группы" />
        <NavItem exact icon={<SegmentIcon />} path={Routes.PromoPeriods} title="Периоды" />
        <NavItem exact icon={<SegmentIcon />} path={Routes.PromoHierarchyLevels} title="Уровни иерархии" />
        <NavItem exact icon={<SegmentIcon />} path={Routes.PromoTargetVariables} title="Параметры функции" />
        <NavItem exact icon={<SegmentIcon />} path={Routes.PromoConstraints} title="Ограничения" />
        <NavItem exact icon={<SegmentIcon />} path={Routes.PromoLogs} title="Логи" />
      </MenuCollapse>
      {IS_RTM_ENABLED && (
        <MenuCollapse icon={<SegmentIcon />} title="RTM">
          <NavItem exact icon={<SegmentIcon />} path={Routes.RtmGroups} title="Группы" />
          <NavItem exact icon={<SegmentIcon />} path={Routes.RtmParameters} title="Параметры" />
        </MenuCollapse>
      )}
      {IS_TETRIS_ENABLED && (
        <MenuCollapse icon={<SegmentIcon />} title="TETRIS">
          <NavItem exact icon={<SegmentIcon />} path={Routes.TetrisGroups} title="Группы" />
          <NavItem exact icon={<SegmentIcon />} path={Routes.TetrisLogs} title="Логи" />
        </MenuCollapse>
      )}
      {IS_CFR_ENABLED && (
        <MenuCollapse icon={<SegmentIcon />} title="CFR">
          <NavItem exact icon={<SegmentIcon />} path={Routes.CfrGroups} title="Группы" />
          <NavItem exact icon={<SegmentIcon />} path={Routes.CfrPfrParams} title="PFR" />
          <NavItem exact icon={<SegmentIcon />} path={Routes.CfrLogs} title="Логи" />
        </MenuCollapse>
      )}
    </List>
  </Menu>
)
